import { SET_LEFT_NAV_COLLECTION, SET_PRODUCT_VIEW_STYLE } from './action';

const initialState = {
  leftNavCollection: [],
  productViewStyle: 'GRID',
};

const catalogReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LEFT_NAV_COLLECTION:
      return {
        ...state,
        leftNavCollection: action.payload,
      };
    case SET_PRODUCT_VIEW_STYLE:
      return {
        ...state,
        productViewStyle: action.payload,
      };
    default:
      return state;
  }
};

export default catalogReducer;
